// extracted by css-extract-rspack-plugin
export default {"cardContentName":"DonationMatchRequestDetailsOrganisationDetailsView_cardContentName__uOE0j"};